import { render, staticRenderFns } from "./PastAwardsImageUpload.vue?vue&type=template&id=2bb71b5a&scoped=true"
import script from "./PastAwardsImageUpload.vue?vue&type=script&lang=js"
export * from "./PastAwardsImageUpload.vue?vue&type=script&lang=js"
import style0 from "./PastAwardsImageUpload.vue?vue&type=style&index=0&id=2bb71b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb71b5a",
  null
  
)

/* custom blocks */
import block0 from "./PastAwardsImageUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports